import { ref, onMounted, onUnmounted, computed } from 'vue'

export const useViewport = () => {
  const width = ref(window.innerWidth)
  const height = ref(window.innerHeight)

  const updateDimensions = () => {
    width.value = window.innerWidth
    height.value = window.innerHeight
  }

  onMounted(() => {
    window.addEventListener('resize', updateDimensions)
  })

  onUnmounted(() => {
    window.removeEventListener('resize', updateDimensions)
  })

  const breakpoint = computed(() => {
    if (width.value < 640) return 'sm'
    if (width.value < 768) return 'md'
    if (width.value < 1024) return 'lg'
    if (width.value < 1280) return 'xl'
    return '2xl'
  })

  const isMobile = computed(() => ['sm', 'md'].includes(breakpoint.value))
  return { width, height, breakpoint, isMobile }
}
